import { getToken } from './session';

export const authHeader = () => {
  const token = getToken();

  if (!token) {
    return {};
  }

  return { Authorization: `Bearer ${token}` };
};
